import { ActionDataType } from '../_reducer/types';
import { locationActionsTypes } from './location.action';
import { LocationTypes } from './location.types';

const initialState: LocationTypes = {
  locations: [],
  locationsWithResidents: [],
  isLoading: false,
  isLoadingWithResidents: false,
  locationsByRegion: []
};

const LocationReducer = (state = initialState, action: ActionDataType) => {
  switch (action.type) {
    case locationActionsTypes.SET_IS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case locationActionsTypes.SET_IS_LOADING_WITH_RESIDENTS:
      return {
        ...state,
        isLoadingWithResidents: true
      };
    case locationActionsTypes.SET_LOCATIONS:
      return {
        ...state,
        locationsByRegion: action.data,
        isLoading: false
      };
    case locationActionsTypes.SET_LOCATIONS_WITH_RESIDENTS:
      return {
        ...state,
        locationsWithResidents: action.data,
        isLoadingWithResidents: false
      };
    default:
      return state;
  }
};
export default LocationReducer;
